<!-- Modo overlay (móvil): fondo oscuro que cierra el panel al tocarlo, igual que shared/ui/modal y drawer. -->
@if (isOverlay()) {
  <button
    type="button"
    class="fixed inset-0 z-40 bg-black/40"
    tabindex="-1"
    aria-label="Cerrar menú"
    data-testid="sidebar-backdrop"
    (click)="closeRequest.emit()"
  ></button>
}

<aside
  #panel
  class="flex select-none flex-col border-r border-border-subtle bg-surface-card focus:outline-none"
  [class]="panelClasses()"
  [attr.role]="isOverlay() ? 'dialog' : null"
  [attr.aria-modal]="isOverlay() ? 'true' : null"
  [attr.tabindex]="isOverlay() ? -1 : null"
  aria-label="Navegación principal"
  (keydown)="onPanelKeydown($event)"
>
  <!-- Cabecera: logo "C" + nombre de marca + botón para colapsar/expandir. -->
  <div class="flex h-16 shrink-0 items-center justify-between border-b border-gray-100 px-5">
    @if (!isCollapsed()) {
      <div class="flex items-center space-x-2.5 overflow-hidden">
        <div
          class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-calypso-primary text-lg font-black text-white shadow-sm"
          aria-hidden="true"
        >
          C
        </div>
        <span class="truncate text-base font-bold tracking-tight text-text-title">Calypso Delivery</span>
      </div>
    }
    <button
      type="button"
      class="rounded-md p-1.5 text-text-muted hover:bg-surface-subtle hover:text-text-title focus:outline-none"
      [attr.aria-label]="toggleLabel()"
      [attr.title]="toggleLabel()"
      data-testid="sidebar-toggle"
      (click)="onToggleClick()"
    >
      <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
  </div>

  <!-- Buscador rápido del árbol de navegación. -->
  @if (!isCollapsed()) {
    <div class="border-b border-gray-100 px-4 py-3.5">
      <div class="relative">
        <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-text-muted">
          <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-4.35-4.35M17 11a6 6 0 11-12 0 6 6 0 0112 0z"
            />
          </svg>
        </span>
        <input
          type="text"
          class="w-full rounded-lg border border-border-subtle bg-gray-50 py-1.5 pl-9 pr-3 text-sm text-text-body placeholder-text-disabled transition focus:border-calypso-primary focus:outline-none focus:ring-1 focus:ring-calypso-primary"
          placeholder="Buscar..."
          [value]="searchTerm()"
          (input)="onSearchInputChange($event)"
          aria-label="Buscar módulos"
        />
      </div>
    </div>
  }

  <!-- Árbol de navegación: módulos con sub-ítems y módulos de enlace directo. -->
  <nav class="flex-1 space-y-1 overflow-y-auto p-3">
    @for (item of items(); track item.id) {
      <div class="mb-1">
        @if (item.subModules && item.subModules.length > 0) {
          <app-sidebar-nav-item
            variant="module"
            [label]="item.name"
            [iconPath]="iconPath(item)"
            [collapsed]="isCollapsed()"
            [expanded]="isExpanded(item.id)"
            [active]="isModuleActive(item)"
            (activate)="toggleExpand(item.id)"
          />

          @if (isExpanded(item.id) && !isCollapsed()) {
            <div class="space-y-1 pb-1 pl-8 pr-2 pt-1">
              @for (child of item.subModules; track child.id) {
                <app-sidebar-nav-item
                  variant="submodule"
                  [label]="child.name"
                  [route]="childRoute(item, child)"
                />
              }
            </div>
          }
        } @else {
          <app-sidebar-nav-item
            variant="link"
            [label]="item.name"
            [iconPath]="iconPath(item)"
            [route]="item.route"
            [collapsed]="isCollapsed()"
          />
        }
      </div>
    }
  </nav>

  <!-- Footer de sesión: nombre + email del usuario y botón de cierre de sesión. -->
  @if (user(); as currentUser) {
    @if (!isCollapsed()) {
      <div class="shrink-0 border-t border-gray-100 p-4">
        <div class="flex flex-col gap-2">
          <div class="min-w-0">
            <p class="truncate text-sm font-semibold text-text-title" [title]="currentUser.name">
              {{ currentUser.name }}
            </p>
            <p class="truncate text-xs text-text-muted" [title]="currentUser.email">
              {{ currentUser.email }}
            </p>
          </div>
          <button
            type="button"
            class="w-full rounded-md border border-border-medium bg-surface-subtle px-2.5 py-1.5 text-sm font-medium text-text-body transition hover:border-gray-400 hover:bg-gray-200 focus:outline-none"
            title="Cerrar sesión actual"
            (click)="logout.emit()"
            data-testid="sidebar-logout"
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    }
  }
</aside>
